import { Directive, ElementRef, Input, OnInit, inject } from '@angular/core';
import { Permission } from 'src/app/common/enums/permissions';
import { AuthService } from 'src/app/core/authentication/auth.service';

@Directive({
  selector: '[visibleWithPermissionsOnWorkerProfile]',
  standalone: false
})
export class VisibleWithPermissionsOrMyProfileDirective implements OnInit {
  private el = inject(ElementRef);
  private authService = inject(AuthService);

  @Input('visibleWithPermissionsOnWorkerProfile') permissions: Permission[];
  @Input() authServerUserId: string;

  constructor() { }

  ngOnInit(): void {
    if (!this.authService.isAuthenticated() || (!this.permissions.some((p) => this.authService.hasPermission(p)) && this.authService.authServerUserId !== this.authServerUserId)) {
      this.el.nativeElement.style.display = 'none';
    }
  }
}
